import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import { useStyles } from "./styles"
import { SelectActionPlanProps } from "./type"

function SelectActionPlan({ items, ...rest }: SelectActionPlanProps) {
    const firstValue = items[0]
    const styles = useStyles({changeColor: items?.length == 2, value: firstValue.value == rest?.value})

    return (
        <ToggleButtonGroup
            exclusive
            aria-label="text alignment"
            sx={styles.container()}
            value={rest?.value || firstValue.value}
            {...rest}
        >
            {items && (
                items.map(options => (
                    <ToggleButton sx={styles.toggle} key={options.id} value={options.value} aria-label="left aligned" disabled={options.value === rest?.value}>
                        {options.label}
                    </ToggleButton>
                ))
            )}
        </ToggleButtonGroup>
    )
}

export default SelectActionPlan